import { toast as rht } from "react-hot-toast";
import type { ToastOptions } from "react-hot-toast";

const options: ToastOptions = {
  duration: 3000,
  position: "top-right",
};

type ToastPromiseParams<T> = {
  loading: string;
  success: string | ((data: T) => string);
  error: string | ((err: unknown) => string);
};

const success = (msg: string) => rht.success(msg, options);

// The message doubles as the toast `id`, so identical errors fired together
// (e.g. two parallel requests both failing with the same 403 "Access
// Denied") show as one toast instead of stacking.
const error = (msg: string) => rht.error(msg, { ...options, id: msg });

// Custom warning using icon and styles
const warning = (msg: string) =>
  rht(msg, {
    ...options,
    icon: "⚠️",
    style: {
      background: "#ffffff",
      color: "#92400e",
    },
  });

const promise = <T,>(myPromise: Promise<T>, msgObj: ToastPromiseParams<T>) =>
  rht.promise(myPromise, msgObj, options);

const toast = {
  success,
  error,
  warning,
  promise,
};

export default toast;
